<template>
	<div class="salesVolume">
		<div class="animated fadeInDown" v-show="!navShow" style="position: fixed;width: 100%;z-index:999;left: 0;right: 0;">
			<HNB ></HNB>
		</div>
		
		
		<div v-show="navShow" class="sales-nav animated fadeInDown"> 
			<div v-for="(item,num) in navAry" :style="num == navValue ? 'border-bottom: #00C785 1px solid; height:30px':' height:30px'" @click="navClick(num)">{{item}}</div>
		</div>
		<div class="sales-top" :style="{top:salesTop + 'px'}" >
			<div v-for="(item,num) in MainImgAry" v-if="num == navValue" >
				<div style="width: 100%; height: 855px;"> </div>
				<div class="sales-Title" :style="{opacity:nameOpacity}">{{item.name}}</div>
				<div class="sales-MainImg" :style="{width: Wwidth < imgMax ? Wwidth + 'px' : imgMax + 'px' ,height:imgMax +'px'}" >
					<div :style="'background-image : url(' + item.imgName + ');background-repeat:no-repeat ;background-position:center center; top:imgTop:' + imgTop + 'rem; width: 100%; height:100%;background-size:' + imgSize + 'px ; ' "></div>
				</div>
				<div class="sales-fuTitle" :style="{top:fuTitleTop +'px'}">
					<div class="sales-fuTitle1">{{item.title}}</div>
					<div class="sales-fuTitle2">{{item.write}}</div>
					<div class="sales-fuTitle2">{{item.write1}}</div>
					<div class="animated fadeInUp" v-show="svgShow"><SvgIcon :svg-name="item.svgName" size="60"></SvgIcon></div>
				</div>
			</div>
		</div>
		
		<div style="position:relative;z-index:777;background-color: rgba(0,0,0,0);">
			<div style="marginTop:1024px;background-color: rgba(244,244,244,1);">
				<div class="sales-brief" v-for="(itemAry,num) in ProductAry" v-if="num == navValue">
					<div v-for="item in itemAry">
						<div class="sales-brief-title">{{item.title}}</div>
						<div class="sales-brief-write">{{item.write}}</div>
						<div class="sales-brief-imgName"><img :src="item.imgName"/></div>
					</div>
				</div>
				<Bottom :BsTitle="bsTitle" ></Bottom>
			</div>
		</div>
		
		
		
		
	</div>
</template>

<script>
	
	import HNB from '../components/HeaderNavigationBar.vue'
	import Bottom from '../components/Bottom.vue'
	import SvgIcon from '../components/SvgIcon.vue'
	
	export default{
		name:"salesVolume",
		data(){
			return{
				bsTitle: ['首页', '销量领先产品'],
				Wwidth:document.body.clientWidth,
				imgMax: 300,
				imgTop: 10.075,
				imgSize:1300,
				svgShow: false,
				navShow: false,
				nameOpacity:1,
				salesTop:0,
				fuTitleTop:550,
				navAry:['TOP 1','TOP 2','TOP 3','TOP 4','TOP 5'],
				navValue: 0,
				MainImgAry:[
					{
						name:'全网销量TOP1产品',
						imgName: this.GLOBAL.imgHost + '/images/salesVolume/molitie.jpg',
						title:'随身魔力按摩贴',
						write:'随身按摩|手法多样',
						write1:'一指操控|小巧便捷',
						svgName: '',
					},{
						name:'全网销量TOP2产品',
						imgName: this.GLOBAL.imgHost + '/images/salesVolume/kaozhen.jpg',
						title:'揉捏按摩靠枕',
						write:'3D按摩|PTC热敷',
						write1:'无线便携|强劲扭力',
						svgName: 'IF',
					},{
						name:'全网销量TOP3产品',
						imgName: this.GLOBAL.imgHost + '/images/salesVolume/anmoyi.jpg',
						title:'眼部冷热按摩仪',
						write:'冷热双感敷眼|自动感应按摩',
						write1:'一键式操作|小巧便携',
						svgName: '',
					},{
						name:'全网销量TOP4产品',
						imgName: this.GLOBAL.imgHost + '/images/salesVolume/zuodian.jpg',
						title:'护腰塑形坐垫',
						write:'矫正坐姿|护腰塑臀',
						write1:'立体包裹|形体支撑',
						svgName: '',
					},{
						name:'全网销量TOP5产品',
						imgName: this.GLOBAL.imgHost + '/images/salesVolume/beikao.jpg',
						title:'人体工学可调背靠',
						write:'环抱式承托|一件升降',
						write1:'扭簧设计|久坐不累',
						svgName: 'IF',
					}
				],
				ProductAry:[[//随心魔力按摩贴
					{
						imgName:this.GLOBAL.imgHost + '/images/salesVolume/molitie_1.jpg',
						title:'随心随行 想按就按',
						write:'放进口袋，随身携带，生活中、旅途中、运动中，只要你想，随时拿出它，给自己疲惫的身体一点完全偷懒的自由！',
					},{
						imgName:this.GLOBAL.imgHost + '/images/salesVolume/molitie_2.jpg',
						title:'传统与科技的领先结合 有助于缓解肌肉不适和疲劳',
						write:'采用TENS低频脉冲按摩技术，有助于缓解肌肉疼痛与疲劳。大师级按摩手法，畅通经络、舒缓神经快速恢复机体活力。',
					},{
						imgName:this.GLOBAL.imgHost + '/images/salesVolume/molitie_3.jpg',
						title:'各部位通用 哪里酸痛贴哪里',
						write:'随心移位，肩部、背部、腰部、四肢等部位都适用',
					}],[{//揉捏按摩靠枕
						imgName:this.GLOBAL.imgHost + '/images/salesVolume/kaozhen_1.jpg',
						title:'放松不受限 随时给身体充电',
						write:'走心设计，摆脱传统电源线的束缚，随时随地都可以给自己解压，帮助恢复身体活力',
						},{
						imgName:this.GLOBAL.imgHost + '/images/salesVolume/kaozhen_2.jpg',
						title:'强劲扭力 揉碎肌肉下的酸痛',
						write:'产品纯铜线电机低噪耐用，持续稳定的动能可以支撑大马力作用，强劲力道直击酸痛处，揉碎肌肉下深层的疲惫感，让身体得到更深入的按摩。',
						},{
						imgName:this.GLOBAL.imgHost + '/images/salesVolume/kaozhen_3.jpg',
						title:'一键式操作 简单易用',
						write:'长按开关机开启/关闭按摩模式，再次短按开启加热按摩模式。',
					}],[{//眼部冷热按摩仪
						imgName:this.GLOBAL.imgHost + '/images/salesVolume/anmoyi_1.jpg',
						title:'多屏时代 您的双眼已经重度疲惫',
						write:'眼镜是心灵的窗口，但生活在快节奏的多屏时代，长时间和电脑手机对视，人均每天用眼超过16小时，眨眼次数超过10000次，眼部问题接踵而来。一款冷热按摩仪可以给你的眼睛做SPA，帮你打开心灵之窗，感受更美视界。',
						},{
						imgName:this.GLOBAL.imgHost + '/images/salesVolume/anmoyi_2.jpg',
						title:'冰爽提神 减少眼部浮肿',
						write:'开启Refresh模式，18℃的冰感能快速赶走疲惫，减少眼部浮肿，让忙碌一天的双眸“睛”力更充沛。',
						},{
						imgName:this.GLOBAL.imgHost + '/images/salesVolume/anmoyi_3.jpg',
						title:'开启Refresh模式，18℃的冰感能快速赶走疲惫，减少眼部浮肿，让忙碌一天的双眸“睛”力更充沛。',
						write:'40℃恒热是缓解敏感眼部肌肤的最佳温度，开启Relieve模式后，将产品覆盖眼部，让眼部四周渐进感受到温柔的暖意，释放眼睛疲劳。',
					}],[{//乐班护腰塑形坐垫
						imgName:this.GLOBAL.imgHost + '/images/salesVolume/zuodian_1.jpg',
						title:'你的私人坐姿矫正专家',
						write:'坐姿不正容易导致肩颈酸痛、驼背、臀部扁平外扩。人体工程学设计、护腰分区支撑系统，保持腰部脊柱呈现自然s型曲线，3D立体包裹，矫正“假胯宽”，矫正骨盆前倾或后倾，防止驼背，轻松“坐”出蜜桃臀，修饰好身材。',
						},{
						imgName:this.GLOBAL.imgHost + '/images/salesVolume/zuodian_2.jpg',
						title:'分区支撑系统 均衡承载体重',
						write:'人体工程学设计、护腰分区支撑系统，贴合人体曲线，全方位支撑你的腰背，帮助脊柱保持自然生理曲线，保持正确坐姿。',
						},{
						imgName:this.GLOBAL.imgHost + '/images/salesVolume/zuodian_3.jpg',
						title:'多种场景 多种生活享受',
						write:'上班工作8小时，均衡释放压力。办公椅放上乐班护腰塑形坐垫，缓解脊柱压力，让你保持正确坐姿，防止驼背',
					}],[{//人体工学可调背靠
						imgName:this.GLOBAL.imgHost + '/images/salesVolume/beikao_1.jpg',
						title:'反正都要坐着 为什么不坐的舒服一点',
						write:'你的一天，超过三分之一的时间都是坐着的状态。然而，大部门的脊椎疾病都是由错误的坐姿所导致。乐范人机工学靠垫，动态承托背部、缓解脊椎压力，怎么靠都舒适。',
						},{
						imgName:this.GLOBAL.imgHost + '/images/salesVolume/beikao_2.jpg',
						title:'创新一键升降 舒适随心选择',
						write:'乐班人机工学靠垫内置升降式机械结构，无需工具即可根据自身需要一键完成动态升降，调整后两侧高度一致，滑槽式设计不易滑落，让依靠更舒适。',
						},{
						imgName:this.GLOBAL.imgHost + '/images/salesVolume/beikao_3.jpg',
						title:'硬核设计 可刚可柔清爽透气',
						write:'乐班人机工学靠垫的背托共有306个透气孔，硬核设计双面透气，夏季使用更清爽。同时预留配件安装孔，可搭配使用海绵软垫，所选用的复合纤维麻灰布搭配质感柔软的原生海绵，冬天使用柔软保暖。',
					}],
				],
			}
		},
		components:{
			HNB,
			Bottom,
			SvgIcon
		},
		mounted() {
			window.addEventListener('scroll', this.getScroll);
			this.scrollToTop();
			console.log(document.body.clientWidth);
			
		
		},
		destroyed() {
			window.removeEventListener('scroll', this.getScroll);
		},
		methods:{
			scrollToTop(){
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				
				if (scrollTop > 0 ) {
					this.$nextTick(() => {
					    setTimeout(() => {
					     document.documentElement.scrollTop = 0;
					    }, 300)
					   })
					
					 
				}
			},
			
			getScroll(e){
				console.log('Scroll'+ e);
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				let pageHeight = document.documentElement.clientHeight;
				console.log('Height'+ scrollTop);
				
				if(scrollTop < 0){
					return;
				}
				var Tophei;
				if(scrollTop > 150){
					this.navShow = true;
				}else{
					this.navShow = false;
				}
				if(scrollTop < 350){
					Tophei = scrollTop
					this.svgShow =false;
				}else{
					Tophei = 350
					this.svgShow =true;
				}
				
				this.salesTop = 0 - Tophei * 1.2;
				this.imgMax = 300 + Tophei *2 ;
				this.imgSize = 1300 - Tophei ;
				this.imgTop = 10.075 + Tophei * 0.5;
				this.fuTitleTop = 600 -  Tophei *0.3;
				this.nameOpacity = 1 - Tophei * 0.01;
					
					

					
					
					
			},
			navClick(num){
				
				document.documentElement.scrollTop = 0;
				this.getScroll();
				this.imgSize = 1300 - 350;
				this.navValue = num;
			}
			
		}
	}
	
</script>

<style>

	
	.salesVolume {
		margin: 0 auto;
		/* max-width: 100%; */
		overflow: hidden;
		max-width: 33.75rem;
		position: relative;
		background-color: rgba(244,244,244,1);
	}
	
	.salesVolume .sales-top{
		position: fixed;
		max-width: 33.75rem;
		width: 100%;

	}
	
	.salesVolume .sales-nav{
		width: 100%;
		max-width: 33.75rem;
		height: 3.6875rem;
		background-color: white;
		position:fixed;
		top: 0;
		z-index: 999;
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		align-items: center;
		margin: 0 auto;
		font-weight: 500;
	}
	
	.salesVolume .sales-Title{
		top: 5.5rem;
		/* margin: 30 auto; */
		margin-top: 30px;
		margin-bottom: 30px;
		width: 100%;
		font-weight: 400;
		font-size: 1.75rem;
		font-family: Alibaba-PuHuiTi-R;
		position: absolute;
	}
	
	.salesVolume .sales-MainImg{
		
		top: 14.075rem;
		left:0;
		right:0;
		bottom:0;
		position: absolute;
		margin: 0 auto;
		max-width: 33.75rem;
	}
	
	.salesVolume .sales-MainImg img{
		margin: 0 auto;
		object-fit: cover;
		width: 16rem;
		height: 16rem;
		
	}
	
	.salesVolume .sales-fuTitle {
		display: flex;
		width: 80%;
		left: 10%;
		flex-direction: column;
		font-family: Alibaba-PuHuiTi-M;
		align-items: flex-start;
		position: absolute;
		
	}
	
	.salesVolume .sales-fuTitle1 {
		margin-top: 5px;
		font-size: 1.75rem;
		font-weight:500;
	}
	
	.salesVolume .sales-fuTitle2 {
		margin-top: 5px;
		font-size: 1.025rem;
		font-weight:500;
	}
	
	.salesVolume .sales-brief{
		width: 100%;
		max-width: 33.75rem;
		display: flex;
		flex-direction: column;
		padding-bottom: 2.5rem;
		/* background-color: #00C785; */
	}
	
	.salesVolume .sales-brief .sales-brief-title{
		padding-top: 2.25rem;
		font-size: 1.0rem;
		font-weight: 600;
		text-align: left;
		width: 85%;
		margin: 0 auto;
		
	}
	
	.salesVolume .sales-brief .sales-brief-write{
		font-size: 0.6rem;
		padding-top: 0.55rem;
		text-align: left;
		width: 85%;
		margin: 0 auto;
	}
	
	.salesVolume .sales-brief .sales-brief-imgName{
		width: 95%;
		
		height: auto;
		margin: 0 auto;
		padding-top: 1.55rem;
	}
	
	.salesVolume .sales-brief .sales-brief-imgName img{
		width: 100%;
		height: 100%;
	}
	
</style>
